<template>
    <div class="round-component" :class="{ 'small': small }" @click="$emit('click')">
        <span class="round-capital">{{ value | firstLetterCapital }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            small: Boolean
        }
    }
</script>